  <div class="container">
    <data-table
    [title]='titleFO'
    [columns]='columnasFO'
    [configuration]='configurationFO'
    [reloadTable]='recargarTablaFO'
    [params]='params'
    [url]='urlTableFO'
    (add)='agregarFO($event)'
    (edit)='editarFO($event)'
    (delete)='eliminarFO($event)'
    (selection)='seleccionadosFO($event)'
    (closeOrder)='closeOrder($event)'
    (print)='print($event)'
    (sendEmail)="sendEmail($event)"
    [headerFilters]="headerFilters"
    [roleId]="roleId"
    [moduleId]="4"
    [subModuleId]="17"
    ></data-table>
   </div>
